import { PROPERTY_FILTER_KEYS } from "@/src/const";
import { DeepSkyType, StrapiCollectionType } from "@/src/type";

function simpleFilter(floorplans: StrapiCollectionType.PropertyFloorplan[], filterType: string) {
  return filterType && filterType !== "perfectMatch"
    ? floorplans.filter((card) => {
        if (filterType === "bedroom0" && card.bedrooms === 0) {
          return true;
        } else if (filterType === "bedroom1" && card.bedrooms === 1) {
          return true;
        } else if (filterType === "bedroom2" && card.bedrooms === 2) {
          return true;
        } else if (filterType === "bedroom3" && card.bedrooms === 3) {
          return true;
        } else if (filterType === "bedroom4" && card.bedrooms === 4) {
          return true;
        } else if (filterType === "specialAvailable" && card.specialAvailable) {
          return true;
        } else if (filterType === "furnished" && card.furnishedAvailable) {
          return true;
        }
        return false;
      })
    : floorplans;
}

function userFilter(floorplans: StrapiCollectionType.PropertyFloorplan[], filters: Record<string, string | string[]>) {
  const FILTER_KEYS = PROPERTY_FILTER_KEYS;
  return Object.values(filters ?? {}).length === 0
    ? floorplans
    : floorplans.filter((card) => {
        //check bedrooms
        if (Array.isArray(filters[FILTER_KEYS.BEDS.param]) && filters[FILTER_KEYS.BEDS.param].length > 0) {
          let canContinue = false;
          for (const bed of filters[FILTER_KEYS.BEDS.param]) {
            if (card.bedrooms === parseInt(bed, 10)) {
              canContinue = true;
              break;
            }
          }
          if (!canContinue) {
            return false;
          }
        }

        //check baths
        if (Array.isArray(filters[FILTER_KEYS.BATHS.param]) && filters[FILTER_KEYS.BATHS.param].length > 0) {
          let canContinue = false;
          for (const bath of filters[FILTER_KEYS.BATHS.param]) {
            if (card.bathrooms === parseInt(bath, 10)) {
              canContinue = true;
              break;
            }
          }
          if (!canContinue) {
            return false;
          }
        }

        //check the budget
        if (filters[FILTER_KEYS.BUDGET.param]) {
          const budget = parseInt(filters[FILTER_KEYS.BUDGET.param] as string, 10);
          if (card.startingAtPrice && card.startingAtPrice > budget) {
            return false;
          }
        }

        //check move-in date
        if (filters[FILTER_KEYS.MOVE_IN_DATE.param]) {
          const moveInDate = new Date(filters[FILTER_KEYS.MOVE_IN_DATE.param] as string);
          const hasAvailableUnits = card.floorplan?.unitTypes?.some((unitType: DeepSkyType.AssetType.PropertyInventory.UnitType) =>
            unitType.units?.some((unit: DeepSkyType.AssetType.PropertyInventory.Unit) => {
              const availabilityDate = unit.availabilityStatus?.date ? new Date(unit.availabilityStatus.date) : null;
              if (availabilityDate && availabilityDate <= moveInDate) {
                return true;
              }

              const externalAvailableDate = unit.external?.availableDate ? new Date(unit.external.availableDate) : null;
              if (externalAvailableDate && externalAvailableDate <= moveInDate) {
                return true;
              }

              return false;
            })
          );

          if (!hasAvailableUnits) {
            return false;
          }
        }

        return true;
      });
}

function getBedroomsTranslation(bedrooms: number, removeBeds: boolean = false) {
  switch (bedrooms ?? -1) {
    case 0:
      return "Studio";
    case 1:
      return removeBeds ? "1" : "1 beds";
    case 2:
      return removeBeds ? "2" : "2 beds";
    case 3:
      return removeBeds ? "3" : "3 beds";
    case 4:
      return removeBeds ? "4" : "4 beds";
    case 5:
      return removeBeds ? "5" : "5 beds";
    default:
      return "";
  }
}

export default {
  simpleFilter,
  userFilter,
  getBedroomsTranslation,
};
